
import React, { createContext, useContext } from 'react';
import { CancerContextType } from './CancerContext.types';

// Add CancerContext export to make it accessible directly
// This helps avoid circular dependencies
export const CancerContext = createContext<CancerContextType | null>(null);

export const useCancer = () => {
  const context = useContext(CancerContext);
  if (!context) {
    throw new Error('useCancer must be used within a CancerProvider');
  }
  return context;
};
